export default [
  {
    path: "/reportDownloadList",
    component: () =>
      import(
        /* webpackChunkName: "reportDownload" */ "@/views/reportDownload/list"
      ),
    name: "reportDownloadList",
    meta: {
      isTab: true,
      keepAlive: false,
      links: ["报告下载"],
      permissionsPath: "/reportDownloadList"
    }
  }
];
